import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ShadowQueryDateProperty, ShadowQueryValueProperty, ShadowQueryValueRangeProperty, ShadowQueryFilterOnValueOnlyProperty } from '../../../shared/services/device-shadow/device-shadow.service';
import { Filter, FilterType, ValueType } from '../query-builder.component';

@Component({
  selector: 'app-query-filter',
  templateUrl: './query-filter.component.html',
  styleUrls: ['./query-filter.component.scss']
})
export class QueryFilterComponent {

  constructor() { }

  @Input() filter: Filter;
  @Output() delete: EventEmitter<Filter> = new EventEmitter<Filter>();

  get properties(): string[] {
    if (this.filter.valueType === ValueType.Date) {
      return Object.values(ShadowQueryDateProperty);
    }

    if (this.filter.valueType === ValueType.Text) {
      return this.filter.filterType === FilterType.Equals
        ? [...Object.values(ShadowQueryValueProperty), ...Object.values(ShadowQueryFilterOnValueOnlyProperty)].sort()
        : Object.values(ShadowQueryValueRangeProperty);
    }

    if (this.filter.valueType === ValueType.Exists || this.filter.valueType === ValueType.DoesNotExist) {
      return [...Object.values(ShadowQueryValueProperty), ...Object.values(ShadowQueryValueRangeProperty), ...Object.values(ShadowQueryDateProperty)].sort();
    }

    return [];
  }

  get propertyName(): string {
    return this.filter.propertyName;
  }

  set propertyName(name: string) {
    this.filter.propertyName = name;
  }

  get value(): string {
    return this.filter.value;
  }

  set value(value: string) {
    this.filter.value = value;
  }

  get operatorText(): string {
    if (this.filter.valueType === ValueType.Date) {
      return this.filter.filterType === FilterType.RangeStart ? 'signal after' : 'signal before';
    }

    if (this.filter.valueType === ValueType.Text) {
      if (this.filter.filterType === FilterType.RangeEnd) {
        return "<=";
      }
      if (this.filter.filterType === FilterType.RangeStart) {
        return ">=";
      }
      return "="
    }

    if (this.filter.valueType === ValueType.Exists) {
      return 'exists';
    }

    if (this.filter.valueType === ValueType.DoesNotExist) {
      return 'does not exist';
    }

    return "not supported";
  }

  get inputType(): string {
    switch (this.filter.valueType) {
      case ValueType.Date:
        return "datetime-local";
      case ValueType.Text:
        return "text";
      default:
        return "text";
    }
  }

  get showInput(): boolean {
    return this.filter.valueType !== ValueType.Exists && this.filter.valueType !== ValueType.DoesNotExist;
  }

  deleteFilter(): void {
    this.delete.emit(this.filter);
  }
}
